<template>
  <div
    v-if="isShow"
    id="simi-dialog-v2"
    v-loading="loading"
    :class="(secondaryLayoutShow && hasCv) || thirdLayoutShow ? 'radish-left-2-of-3' : 'radish-left-1-of-3'"
  >
    <el-card v-show="primaryLayoutShow" class="simi-wapper simi-wapper-v2" style="padding:5px !important;">
      <div slot="header" class="clearfix">
        <span class="lg-font">协会数据 </span> <span class="sm-font subtitle-color">{{ bindText }}</span>
        <i class="el-icon-close xl-font" style="float: right; padding: 3px 0" @click="isShow = false"></i>
      </div>
      <div class="simi-wapper md-font">
        <div v-if="(status === 1 || status === 3) && radish">
          <div class="margin-vertical-md subtext-color">当前系统人选信息:</div>
          <el-row class="margin-left-md" :gutter="2">
            <el-col :span="5"><span class="subtext-color">姓名:</span> {{ radish.姓名 || '--' }}</el-col>
            <el-col :span="5"><span class="subtext-color">公司:</span> {{ radish.公司 || '--' }}</el-col>
            <el-col :span="9"
              ><span class="subtext-color">职能模块:</span>
              {{
                radish.职能模块 ? (Array.isArray(radish.职能模块) ? radish.职能模块.join(';') : radish.职能模块) : '--'
              }}</el-col
            >
            <el-col :span="4"><span class="subtext-color">学历:</span> {{ radish.学历 || '--' }}</el-col>
          </el-row>
        </div>
        <div v-if="status === 1 && radish">
          <div class="margin-vertical-md subtext-color">工作经历:</div>
          <el-row
            v-for="(exp, index) in exps"
            :key="`radish-bind-exp-${exp._id}-${index}`"
            class="margin-left-md margin-vertical-sm"
            :gutter="2"
          >
            <el-col :span="5">{{ exp.公司 || '--' }}</el-col>
            <el-col :span="5">{{ exp.部门 || '--' }}</el-col>
            <el-col :span="6">{{ exp.目前职位 || '--' }}</el-col>
            <el-col :span="6">{{ exp.起始时间 || exp.结束时间 ? `${exp.起始时间} - ${exp.结束时间}` : '--' }}</el-col>
          </el-row>
        </div>
        <div v-if="status === 1" class="dot-rectange-class">
          <div class="margin-vertical-md subtext-color">
            协会人选信息 <span class="sm-font subtitle-color">(以下人选数据来自协会,点击绑定可以和系统人选关联)</span>
          </div>
          <div class="simi-wapper">
            <table class="a-table sm-font" cellspacing="0" style="width:100%;text-align:center;font-size: 12px;">
              <tr>
                <th style="width:40px">操作</th>
                <th style="width:60px">变动经历</th>
                <th style="width:60px">姓名</th>
                <th style="width:40px">性别</th>
                <th style="width:140px">公司</th>
                <th style="width:80px">学历</th>
                <th style="width:100px">从业资格</th>
                <th style="width:100px">登记日期</th>
              </tr>
              <tr v-for="(thirdPerson, index) in thirdPersons" :key="`radish-bind-thirdperson-${index}`">
                <td><span class="primary-text-color cursor-pointer" @click="bindThird(thirdPerson)">绑定</span></td>
                <td>
                  <el-popover
                    placement="right-start"
                    title="注册变更记录"
                    width="450"
                    trigger="click"
                    @show="showHistory(thirdPerson)"
                  >
                    <div class="radish-dia-body simi-box">
                      <table class="a-table sm-font" cellspacing="0" style="width:100%;text-align:center">
                        <tr>
                          <th style="width:120px">公司</th>
                          <th style="width:80px">从业资格</th>
                          <th style="width:100px">登记状态</th>
                          <th style="width:100px">证书取得日期</th>
                        </tr>
                        <tr v-for="(his, k) in history" :key="`simi-history-${k}`">
                          <td>{{ his['公司'] }}</td>
                          <td>{{ his['执业岗位'] }}</td>
                          <td>{{ his['证书状态'] }}</td>
                          <td>{{ his['证书取得日期'] }}</td>
                        </tr>
                      </table>
                    </div>
                    <span slot="reference" class="primary-text-color cursor-pointer">查看变动</span>
                  </el-popover>
                </td>
                <td>{{ thirdPerson['姓名'] || radish.姓名 || '' }}</td>
                <td>{{ thirdPerson['性别'] || '' }}</td>
                <td>{{ thirdPerson['公司'] || '' }}</td>
                <td>{{ thirdPerson['学历'] || '' }}</td>
                <td>{{ thirdPerson['执业岗位'] || '' }}</td>
                <td>{{ thirdPerson['证书取得日期'] || '' }}</td>
              </tr>
            </table>
          </div>
          <el-row type="flex" justify="end">
            <el-col :span="6"
              ><div style="text-align:center">
                <el-button
                  class="primary-button-color white-color sm-font margin-vertical-md"
                  size="mini"
                  @click="searchSimi"
                  >查看更多协会数据</el-button
                >
              </div></el-col
            >
          </el-row>
        </div>
        <div v-if="status > 1">
          <div class="margin-vertical-md subtext-color">已绑定协会人选基本信息:</div>
          <div v-if="person" class="simi-wapper">
            <table class="a-table" cellspacing="0" style="text-align:center">
              <tr>
                <td class="title-td">姓名</td>
                <td class="text-td">{{ person['姓名'] || radish.姓名 || '--' }}</td>
                <td class="title-td">性别</td>
                <td class="text-td">{{ person['性别'] || '--' }}</td>
              </tr>
              <tr>
                <td class="title-td">公司</td>
                <td class="text-td">{{ person['公司'] || '--' }}</td>
                <td class="title-td">证书编号</td>
                <td class="text-td">{{ person['证书编号'] || '--' }}</td>
              </tr>
              <tr>
                <td class="title-td">从业资格</td>
                <td class="text-td">{{ person['执业岗位'] || '--' }}</td>
                <td class="title-td">学历</td>
                <td class="text-td">{{ person['学历'] || '--' }}</td>
              </tr>
              <tr>
                <td class="title-td">登记日期</td>
                <td class="text-td">{{ person['证书取得日期'] || '--' }}</td>
                <td class="title-td">登记状态</td>
                <td class="text-td">{{ person['状态'] || '--' }}</td>
              </tr>
            </table>
          </div>
          <div class="margin-vertical-md subtext-color">协会人选登记变更信息:</div>
          <div v-if="person && person.注册变更记录" class="simi-wapper">
            <table class="a-table sm-font" cellspacing="0" style="width:100%;text-align:center">
              <tr>
                <th style="width:100px">证书编号</th>
                <th style="width:80px">登记日期</th>
                <th style="width:150px">公司</th>
                <th style="width:100px">从业资格</th>
                <th style="width:80px">登记状态</th>
                <th v-if="person.来源 === 'sac'">离职登记日期</th>
              </tr>
              <tr v-for="(his, k) in person.注册变更记录" :key="`person-history-${k}`">
                <td>{{ his['证书编号'] }}</td>
                <td>{{ his['证书取得日期'] }}</td>
                <td>{{ his['公司'] }}</td>
                <td>{{ his['执业岗位'] }}</td>
                <td>{{ his['证书状态'] }}</td>
                <td v-if="person.来源 === 'sac'">{{ his['离职时间'] }}</td>
              </tr>
            </table>
          </div>
          <el-row type="flex" justify="end">
            <el-col :span="14"
              ><div class="align-center">
                <el-tooltip effect="dark" content="点击把协会人选变更信息添加到系统人选工作经历中" placement="top-end">
                  <el-button
                    v-if="status === 2"
                    class="primary-button-color white-color sm-font margin-vertical-md"
                    size="mini"
                    @click="bindThird(person)"
                    >添加工作经历</el-button
                  ></el-tooltip
                >
                <el-tooltip effect="dark" content="点击把协会人选的公司同步到系统人选上" placement="top-end">
                  <el-button
                    v-if="status === 3"
                    class="primary-button-color white-color sm-font margin-vertical-md"
                    size="mini"
                    @click="syncCompany"
                    >同步公司</el-button
                  >
                </el-tooltip>
                <el-button
                  v-if="status === 4"
                  class="primary-button-color white-color sm-font margin-vertical-md"
                  size="mini"
                  @click="editExps"
                  >编辑工作经历</el-button
                >
                <el-button
                  class="primary-button-color white-color sm-font margin-vertical-md"
                  size="mini"
                  @click="searchSimi"
                  >查看更多协会数据</el-button
                >
                <el-button
                  v-if="status === 2 || status === 3 || status === 4"
                  class="disable-button-color white-color sm-font margin-vertical-md"
                  size="mini"
                  @click="unbindThird"
                  >解绑</el-button
                >
              </div></el-col
            >
          </el-row>
        </div>
      </div>
    </el-card>
    <el-card v-if="secondaryLayoutShow" class="simi-wapper simi-wapper-v2" style="padding:5px !important;">
      <div slot="header" class="clearfix">
        <span v-if="hasCv && file" class="lg-font blue-color bold-font">{{ file.originalname || '--' }} </span>
        <span v-if="!hasCv || !file" class="lg-font blue-color bold-font"> &nbsp;&nbsp; </span>
        <i class="el-icon-close xl-font" style="float: right; padding: 3px 0" @click="openPrimaryLayout"></i>
      </div>
      <div class="simi-wapper md-font" style="display: flex">
        <div v-if="hasCv && file" class="left-side">
          <div v-if="previewUrl" style="height:98%;position:relative">
            <div
              v-show="isOfficeUrl"
              id="testIframe-in-simi-dialog"
              style="height:78vh !important;width:36vw !important;"
            ></div>
            <img v-show="isImgUrl" :src="previewUrl" />
          </div>
        </div>
        <div class="full-size">
          <el-row>
            <el-col :span="10">
              <div class="blue-color-2 margin-md padding-md">
                <div class="md-font margin-bottom-md">{{ radish.姓名 }}</div>
                <div v-if="radish.公司" class="margin-bottom-md sm-font">{{ radish.公司 }}</div>
                <div>
                  <span v-if="radish.职能模块 && radish.职能模块.length > 0" class="sm-font">{{
                    Array.isArray(radish.职能模块) ? radish.职能模块.join(';') : radish.职能模块 || ''
                  }}</span>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span v-if="radish.职位">{{ radish.职位 }}</span>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <img style="height: 60px;margin-top: 40px;" src="../../../assets/images/fill-exp-font.png" />
            </el-col>
            <el-col :span="6">
              <img style="height: 120px;margin-left: 20px;" src="../../../assets/images/smart-a-1.png" />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <hr style="border:1px dashed #CCCCCC;margin: 10px;" />
              <div class="margin-md padding-md">
                <div class="lg-font blue-color-2">系统人选经历信息</div>
                <div class="sm-font orange-color">记得帮小阿点击下"保存"</div>
                <el-row
                  v-for="(exp, index) in rightExps"
                  :key="`rightExps-exp--${index}`"
                  :class="exp._id ? 'radish-exp-row' : 'radish-exp-row gray-background-color '"
                  :gutter="1"
                >
                  <el-col :span="20">
                    <div style="margin-bottom: 5px">{{ exp.公司 }} {{ exp.目前职位 }}</div>
                    <div>{{ exp.起始时间 }} - {{ exp.结束时间 }}</div>
                  </el-col>
                  <el-col :span="4"
                    ><div style="text-align: center;margin-top: 5px;">
                      <span class="red-color" @click.stop.prevent="confirmDeleteRight(exp, index)">删除</span>
                    </div></el-col
                  >
                </el-row>
                <el-button
                  class="white-color sm-font full-width"
                  style="background-color:#6A96A7"
                  size="mini"
                  @click="confirmBind"
                  >保 &nbsp;&nbsp; 存</el-button
                >
              </div>
            </el-col>
            <el-col :span="12">
              <div
                style="border-top: 4px solid #CCCCCC;border-left: 4px solid #CCCCCC; min-height: 65vh;height: calc( 100vh - 270px );"
              >
                <div class="margin-md padding-md">
                  <div class="lg-font blue-color-2">协会人选经历信息</div>
                  <div class="sm-font orange-color">点击"添加"即可把协会人选经历信息添加到左侧系统信息</div>
                  <el-row
                    v-for="(exp, index) in leftExps"
                    :key="`leftExps-exp--${index}`"
                    class="radish-exp-row"
                    :gutter="1"
                  >
                    <el-col :span="19">
                      <div style="margin-bottom: 5px">{{ exp.公司 }} {{ exp.目前职位 }}</div>
                      <div>{{ exp.起始时间 }} - {{ exp.结束时间 }}</div>
                    </el-col>
                    <el-col :span="5"
                      ><div style="text-align: center;">
                        <el-button
                          v-if="!exp.hasAdd"
                          class="white-color"
                          size="mini"
                          style="background-color:#6A96A7;padding: 5px 8px;border-radius:5px !important;margin-top: 5px;"
                          @click.stop.prevent="addToRight(exp, index)"
                          >添加</el-button
                        ><el-button v-if="exp.hasAdd" type="text" size="mini" style="color:#6A96A7;margin-top: 5px"
                          >已添加</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <div class="align-center" style="text-align: right">
                    <el-tooltip effect="dark" content="把协会变动经历覆盖到系统人选工作经历上" placement="top-end">
                      <el-button
                        class="disable-button-color white-color sm-font margin-vertical-md"
                        size="mini"
                        @click="replaceAllExpsConfirm"
                        >全部替换</el-button
                      ></el-tooltip
                    >
                    <el-button
                      class="white-color sm-font margin-vertical-md"
                      style="background-color:#6A96A7"
                      size="mini"
                      @click="addAllToRight"
                      >全部添加</el-button
                    >
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-card>
    <template v-if="thirdLayoutShow">
      <el-row style="height:100%">
        <el-col :span="12" style="height:100%">
          <el-card class="simi-wapper simi-wapper-v2" style="padding:5px !important;">
            <div slot="header" class="clearfix">
              <span class="lg-font">协会数据 </span> <span class="sm-font subtitle-color">{{ bindText }}</span>
              <i class="el-icon-close xl-font" style="float: right; padding: 3px 0" @click="isShow = false"></i>
            </div>
            <div class="simi-wapper md-font">
              <div v-if="status > 1">
                <div class="margin-vertical-md subtext-color">已绑定协会人选基本信息:</div>
                <div v-if="person" class="simi-wapper">
                  <table class="a-table" cellspacing="0" style="text-align:center">
                    <tr>
                      <td class="title-td">姓名</td>
                      <td class="text-td">{{ person['姓名'] || radish['姓名'] || '' }}</td>
                      <td class="title-td">性别</td>
                      <td class="text-td">{{ person['性别'] || '' }}</td>
                    </tr>
                    <tr>
                      <td class="title-td">公司</td>
                      <td class="text-td">{{ person['公司'] || '' }}</td>
                      <td class="title-td">证书编号</td>
                      <td class="text-td">{{ person['证书编号'] || '' }}</td>
                    </tr>
                    <tr>
                      <td class="title-td">从业资格</td>
                      <td class="text-td">{{ person['执业岗位'] || '' }}</td>
                      <td class="title-td">学历</td>
                      <td class="text-td">{{ person['学历'] || '' }}</td>
                    </tr>
                    <tr>
                      <td class="title-td">登记日期</td>
                      <td class="text-td">{{ person['证书取得日期'] || '' }}</td>
                      <td class="title-td">登记状态</td>
                      <td class="text-td">{{ person['状态'] || '' }}</td>
                    </tr>
                  </table>
                </div>
                <div class="margin-vertical-md subtext-color">协会人选登记变更信息:</div>
                <div v-if="person && person.注册变更记录" class="simi-wapper">
                  <table class="a-table sm-font" cellspacing="0" style="width:100%;text-align:center">
                    <tr>
                      <th style="width:100px">证书编号</th>
                      <th style="width:80px">登记日期</th>
                      <th style="width:150px">公司</th>
                      <th style="width:100px">从业资格</th>
                      <th style="width:80px">登记状态</th>
                      <th v-if="person.来源 === 'sac'">离职登记日期</th>
                    </tr>
                    <tr v-for="(his, k) in person.注册变更记录" :key="`person-history-${k}`">
                      <td>{{ his['证书编号'] }}</td>
                      <td>{{ his['证书取得日期'] }}</td>
                      <td>{{ his['公司'] }}</td>
                      <td>{{ his['执业岗位'] }}</td>
                      <td>{{ his['证书状态'] }}</td>
                      <td v-if="person.来源 === 'sac'">{{ his['离职时间'] }}</td>
                    </tr>
                  </table>
                </div>
                <el-row type="flex" justify="end">
                  <el-col :span="12"
                    ><div class="align-center">
                      <el-tooltip
                        effect="dark"
                        content="点击把协会人选变更信息添加到系统人选工作经历中"
                        placement="top-end"
                      >
                        <el-button
                          v-if="status === 2"
                          class="primary-button-color white-color sm-font margin-vertical-md"
                          size="mini"
                          @click="bindThird(person)"
                          >添加工作经历</el-button
                        ></el-tooltip
                      >
                      <el-tooltip effect="dark" content="点击把协会人选的公司同步到系统人选上" placement="top-end">
                        <el-button
                          v-if="status === 3"
                          class="primary-button-color white-color sm-font margin-vertical-md"
                          size="mini"
                          @click="syncCompany"
                          >同步公司</el-button
                        >
                      </el-tooltip>
                      <el-button
                        v-if="status === 4"
                        class="primary-button-color white-color sm-font margin-vertical-md"
                        size="mini"
                        @click="editExps"
                        >编辑工作经历</el-button
                      >
                      <el-button
                        class="primary-button-color white-color sm-font margin-vertical-md"
                        size="mini"
                        @click="searchSimi"
                        >查看更多协会数据</el-button
                      >
                      <el-button
                        v-if="status === 2 || status === 3 || status === 4"
                        class="disable-button-color white-color sm-font margin-vertical-md"
                        size="mini"
                        @click="unbindThird"
                        >解绑</el-button
                      >
                    </div></el-col
                  >
                </el-row>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12" style="height:100%">
          <el-card class="simi-wapper simi-wapper-v2" style="padding:5px !important;">
            <div slot="header" class="clearfix">
              <span class="lg-font">工作经历编辑 </span
              ><i class="el-icon-close xl-font" style="float: right; padding: 3px 0" @click="openPrimaryLayout"></i>
            </div>
            <div class="simi-wapper md-font">
              <el-row type="flex" justify="end" style="margin-bottom: 80px;">
                <el-col :span="15">
                  <div class="left-bubble-rect sm-font mid-size">
                    协会上人选离职注销了，快快看看系统上他的工作经历是否正确
                  </div>
                </el-col>
                <el-col :span="6"> <img style="height: 150px" src="../../../assets/images/smart-a-1.png" /> </el-col>
              </el-row>
              <div>
                <div class="rde-exp-title">
                  <span>{{ radish.姓名 || '--' }}的工作经历</span>
                  <i class="el-icon-circle-plus rde-exp-icon" title="添加" @click="addExp('工作')"></i>
                </div>
                <div v-if="exps && exps.length > 0">
                  <template v-for="(work, k) in exps">
                    <div :key="k" class="rde-exp-item">
                      <el-input v-model="work['公司']" size="mini" placeholder="公司" :title="work['公司']" />
                      <el-input v-model="work['部门']" size="mini" placeholder="部门" :title="work['部门']" />
                      <el-input
                        v-model="work['目前职位']"
                        size="mini"
                        placeholder="目前职位"
                        :title="work['目前职位']"
                      />
                      <el-date-picker
                        v-model="work['起始时间']"
                        size="mini"
                        type="month"
                        format="yyyy.MM"
                        value-format="yyyy.MM"
                        placeholder="起始时间"
                        @change="valiTime(work['起始时间'], work['结束时间'])"
                      ></el-date-picker>
                      <el-date-picker
                        v-model="work['结束时间']"
                        size="mini"
                        type="month"
                        format="yyyy.MM"
                        value-format="yyyy.MM"
                        placeholder="结束时间"
                        @change="valiTime(work['起始时间'], work['结束时间'])"
                      ></el-date-picker>
                      <i class="el-icon-remove rde-exp-icon" title="删除" @click="delExp(k, work)"></i>
                    </div>
                  </template>
                </div>
              </div>
              <div class="align-center" style="margin-left: 85%;width: 15%">
                <el-button
                  class="primary-button-color white-color sm-font margin-vertical-md"
                  size="mini"
                  @click="saveExp"
                  >确定</el-button
                >
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </template>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible1"
      width="20%"
      custom-class="dialog-exp-edit"
      :style="`top: 25vh; left:${(secondaryLayoutShow && hasCv) || thirdLayoutShow ? -5 : -50}vw`"
      :modal="false"
      :before-close="
        () => {
          loading = false
          dialogVisible1 = false
        }
      "
    >
      <span>确定把协会人选经历覆盖到系统人选工作经历上吗?</span>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            () => {
              dialogVisible1 = false
              loading = false
            }
          "
          >取 消</el-button
        >
        <el-button type="primary" @click="replaceAllExps">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible2"
      width="20%"
      custom-class="dialog-exp-edit"
      :style="`top: 25vh; left:${(secondaryLayoutShow && hasCv) || thirdLayoutShow ? -5 : -50}vw`"
      :modal="false"
      :before-close="
        () => {
          loading = false
          dialogVisible2 = false
        }
      "
    >
      <span>确定删除该经历吗?</span>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            () => {
              dialogVisible2 = false
              loading = false
            }
          "
          >取 消</el-button
        >
        <el-button type="primary" @click="deleteRight">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible3"
      width="20%"
      custom-class="dialog-exp-edit"
      :style="`top: 25vh; left:${(secondaryLayoutShow && hasCv) || thirdLayoutShow ? -5 : -50}vw`"
      :modal="false"
      :before-close="
        () => {
          loading = false
          dialogVisible3 = false
        }
      "
    >
      <span>是否同步添加工作经历?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateCompany(person.公司)">不添加经历</el-button>
        <el-button type="primary" @click="bindThird(person, true)">添加经历</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible4"
      width="20%"
      custom-class="dialog-exp-edit"
      :style="`top: 25vh; left:${(secondaryLayoutShow && hasCv) || thirdLayoutShow ? -5 : -50}vw`"
      :modal="false"
      :before-close="
        () => {
          loading = false
          dialogVisible4 = false
        }
      "
    >
      <span>系统人选没有工作经历，已经自动把协会经历添加到人选详情</span>
      <span slot="footer" class="dialog-footer"> <el-button @click="dialogVisible4 = false">确定</el-button> </span>
    </el-dialog>
  </div>
</template>
<script>
// import WPSOfficeSDK from '../../../assets/weboffice/web-office-sdk-v1.1.2.es'

const shortid = require('shortid')
const dateformat = require('dateformat')

const bindTexts = [
  '(未绑定)',
  '(已绑定)',
  '(有变动,系统人选公司和协会人选当前公司不一致)',
  '(已离职,协会中离职注销没有下家公司)',
]
export default {
  data: function() {
    return {
      isShow: false,
      primaryLayoutShow: true, // 主显示层
      secondaryLayoutShow: false, // 副显示层
      thirdLayoutShow: false, // 工作经历编辑显示层
      hasCv: false,
      file: {},
      radish: {},
      history: [],
      status: 0,
      person: {},
      thirdPersons: [],
      bindText: '',
      exps: [],
      previewUrl: '',
      isXiehuiCompany: false,
      isSysCompany: true,
      company: '',
      bindPerson: {},
      leftExps: [],
      leftExpsBackup: [],
      rightExps: [],
      hasBind: false,
      loading: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      delExpHelper: null,
      delExpIndex: null,
      config: {
        document: {
          fileType: 'docx',
          key: '',
          title: '',
          permissions: {
            chat: false,
            comment: false,
            copy: false,
            download: false,
            edit: false,
            fillForms: false,
            modifyContentControl: false,
            modifyFilter: false,
            print: false,
            review: false,
            reviewGroups: null,
            commentGroups: {},
            userInfoGroups: null,
          },
          // url: 'https://alphahr.oss-cn-beijing.aliyuncs.com/public/test1.html',
          url:
            'https://alphahr.oss-cn-beijing.aliyuncs.com/public/d32bfbcd863860b41535f5fc1923396d.%E6%98%93%E7%A5%96%E6%B1%9F-%E7%A8%8E%E5%8A%A1%E8%B4%9F%E8%B4%A3%E4%BA%BA-%E4%B8%AD%E5%A4%96%E5%90%88%E8%90%A5%EF%BC%88%E5%90%88%E8%B5%84%C2%B7%E5%90%88%E4%BD%9C%EF%BC%89-%E7%94%B7-32%E5%B2%81-%E7%A1%95%E5%A3%AB-8%E5%B9%B4%E4%BB%A5%E4%B8%8A%E5%B7%A5%E4%BD%9C%E7%BB%8F%E9%AA%8C%E7%8C%8E%E8%81%98%E7%AE%80%E5%8E%86.docx',
        },
        documentType: 'word',
        editorConfig: {
          actionLink: null,
          callbackUrl: 'http://47.93.158.22:11000/example/track?filename=new.docx&useraddress=27.47.132.115',
          coEditing: null,
          createUrl: null,
          customization: {
            about: false,
            comments: false,
            feedback: false,
            forcesave: false,
            submitForm: false,
            compactHeader: true,
            compactToolbar: true,
            hideRightMenu: true,
            hideRulers: true,
            toolbarNoTabs: true,
            // zoom: -1,
            features: {
              spellcheck: false,
            },
            integrationMode: 'embed',
            logo: {
              image: 'https://alphahr.oss-cn-beijing.aliyuncs.com/public/assets/alpha-logo.png',
            },
          },
          user: {
            group: '',
            id: app.user._id,
            name: app.user.account || 'test',
          },
          region: 'zh-CN',
          lang: 'zh-CN',
          plugins: false,
        },
        mode: 'view',
        height: '100%',
        width: '100%',
        type: 'desktop',
      },
      originalname: '',
      documentType: 'word',
      fileType: 'docx',
      md5: '',
      docEditor: null,
    }
  },
  computed: {
    isOfficeUrl() {
      const wordTypeReg = /(\.doc)|(\.docm)|(\.docx)|(\.docxf)|(\.dot)|(\.dotm)|(\.dotx)|(\.epub)|(\.fodt)|(\.fb2)|(\.htm)|(\.html)|(\.mht)|(\.odt)|(\.oform)|(\.ott)|(\.oxps)|(\.pdf)|(\.rtf)|(\.txt)|(\.djvu)|(\.xml)|(\.xps)/
      const excelTypeReg = /(\.csv)|(\.fods)|(\.ods)|(\.ots)|(\.xls)|(\.xlsb)|(\.xlsm)|(\.xlsx)|(\.xlt)|(\.xltm)|(\.xltx)/
      const pptTypeReg = /(.fodp)|(\.odp)|(\.otp)|(\.pot)|(\.potm)|(\.potx)|(\.pps)|(\.ppsm)|(\.ppsx)|(\.ppt)|(\.pptm)|(\.pptx)/
      return wordTypeReg.test(this.previewUrl) || excelTypeReg.test(this.previewUrl) || pptTypeReg.test(this.previewUrl)
    },
    isImgUrl() {
      return /(\.png)|(\.jpg)|(\.jpeg)/.test(this.previewUrl)
    },
  },
  methods: {
    show: async function(radish) {
      this.history = []
      this.radish = radish
      this.status = 0
      this.person = {}
      this.thirdPersons = []
      this.exps = []
      this.bindText = ''
      this.primaryLayoutShow = true
      this.secondaryLayoutShow = false
      this.thirdLayoutShow = false
      this.hasCv = false
      this.file = {}
      this.previewUrl = ''
      this.leftExps = []
      this.rightExps = []
      this.leftExpsBackup = []
      this.hasBind = false
      this.dialogVisible1 = false
      this.dialogVisible2 = false
      this.dialogVisible3 = false
      this.dialogVisible4 = false
      this.delExpHelper = null
      this.delExpIndex = null
      const result = await app.service('radish').listSimilarityV2({ rid: radish._id })
      if (result.status == 'success' && result.data) {
        this.status = result.data.status
        if (result.data.person) {
          this.person = result.data.person
        }
        if (result.data.thirdPersons) {
          this.thirdPersons = result.data.thirdPersons
        }
      }
      if (this.status > 0) {
        this.bindText = bindTexts[this.status - 1]
        if (this.status === 1) {
          // 获取工作经历
          this.exps = await this.getRadishExps()
        }
        this.isShow = true
      } else {
        this.$message('没有协会人选记录')
      }
      if (this.status !== this.radish.status) {
        this.refreshRadishList()
      }
    },
    async getRadish() {
      const res = await app.service('radish').fetch({ _id: this.radish._id })
      if (res.status === 'success') {
        if (res.data.length === 0) {
          this.$message.error('人选不存在')
          return
        }
        return res.data[0]
      }
    },
    async getRadishExps(force) {
      if (!force && this.radish.experiences) {
        return this.radish.experiences
      }
      const radish = await this.getRadish()
      let exps = []
      if (radish && radish.experiences.length > 0) {
        radish.experiences.forEach(exp => {
          if (exp.type === '工作') {
            exps.push(exp)
          }
        })
      }
      exps = this.sortExpByTime(exps)
      if (force) {
        this.exps = exps
      }
      return exps
    },
    clickName: function(item) {
      window.open(`${window.frontend}/#/radish-detail-blank/${item.person._id}`, '_blank')
    },
    showHistory: function(item) {
      this.history = item['注册变更记录'] || []
    },
    searchSimi() {
      return window.open(`${window.frontend}/#/contactlists?radishName=${this.radish.姓名}`)
    },
    async bindThird(thirdPerson, hasBind) {
      this.bindPerson = thirdPerson
      this.company = this.radish.公司
      if (hasBind) {
        this.hasBind = hasBind
        if (thirdPerson.公司) {
          await this.updateCompany(thirdPerson.公司)
        }
      }
      this.leftExps = []
      const exps = []
      thirdPerson.注册变更记录.forEach(item => {
        const startTime = item.证书取得日期 && new Date(item.证书取得日期)
        const endTime =
          (item.离职时间 && new Date(item.离职时间)) || (item.证书有效截止日期 && new Date(item.证书有效截止日期))
        const start = (startTime && dateformat(startTime, 'yyyy.mm')) || item.证书取得日期
        const end = (endTime && dateformat(endTime, 'yyyy.mm')) || item.离职时间 || item.证书有效截止日期
        const exp = {
          公司: item.公司,
          起始时间: start,
          结束时间: end,
          type: '工作',
          from: 'thirdperson',
          rid: this.radish._id,
        }
        exps.push(exp)
      })
      this.leftExps = this.sortExpByTime(exps)
      this.leftExps.forEach((v, i) => {
        v.index = i
      })
      this.exps = await this.getRadishExps()
      this.rightExps = this.sortExpByTime(JSON.parse(JSON.stringify(this.exps)))
      if (this.rightExps.length === 0) {
        this.rightExps = this.leftExps.slice(0)
        await this.confirmBind()
        this.$nextTick(() => {
          this.leftExps = []
          this.rightExps = []
          // this.$alert('系统人选没有工作经历，已经自动把协会经历添加到人选详情', '提示', {
          //   confirmButtonText: '确定',
          //   confirmButtonClass: 'primary-button-color white-color sm-font',
          // })
          //   .then(() => {})
          //   .catch(() => {})
          this.dialogVisible4 = false
        })
        return
      }
      this.leftExpsBackup = this.leftExps.slice(0)
      this.loading = false
      this.dialogVisible3 = false
      this.openSecondaryLayout()
    },
    openPrimaryLayout() {
      this.primaryLayoutShow = true
      this.secondaryLayoutShow = false
      this.thirdLayoutShow = false
    },
    async openSecondaryLayout() {
      const result = await app.service('radish').listAttachment({ rid: this.radish._id })
      if (result && result.status === 'success') {
        const validCvs = (result.data || [])
          .filter(a => ['原始简历', 'cv'].includes(a.type))
          .sort((a, b) => (!b.createdAt || a.createdAt > b.createdAt ? -1 : 1))
        this.hasCv = validCvs.length > 0
        this.file = validCvs[0] || {}
        if (this.hasCv) {
          this.primaryLayoutShow = false
          this.secondaryLayoutShow = true
          await this.getFile(this.file)
        }
      }
      this.primaryLayoutShow = false
      this.secondaryLayoutShow = true
    },
    destoryEditor() {
      this.docEditor && this.docEditor.destroyEditor()
      this.docEditor = null
    },
    async getFile({ md5, fileId, _id }) {
      if (!md5 && !fileId && !_id) return
      try {
        const query = md5 ? { md5 } : fileId || _id ? { _id: fileId || _id } : undefined
        const src = await window.app.service('file').buildPreview(query)
        const url = src.url
        if (window.location.origin.indexOf('https://') !== -1) {
          this.previewUrl = url.replace('http://', 'https://')
        } else if (window.location.origin.indexOf('http://') !== -1) {
          this.previewUrl = url.replace('https://', 'http://')
        }
        this.documentType = src.documentType
        this.originalname = src.originalname
        this.fileType = src.fileType
        this.md5 = src.md5
        this.showFile()
      } catch (error) {
        this.$message.error(`预览：${(error.response && error.response.message) || error.message}`)
        // this.close()
      }
      // this.loading = false
    },
    showFile() {
      if (this.isOfficeUrl) {
        this.config.documentType = this.documentType
        this.config.document.fileType = this.fileType
        this.config.document.key = this.md5
        this.config.document.title = this.originalname
        this.config.document.url = this.previewUrl
        this.config.events = {
          onError: this.destoryEditor(),
          onRequestClose: this.destoryEditor(),
        }
        if (this.isShuju || this.isAdmin) {
          this.config.document.permissions.copy = true
        }
      }
      this.$nextTick(() => {
        if (!this.docEditor && this.isOfficeUrl) {
          this.docEditor = new window.DocsAPI.DocEditor('testIframe-in-simi-dialog', this.config)
        }
      })
    },
    handleSelectCompany(type) {
      if (type === '协会') {
        this.isSysCompany = false
        this.company = this.bindPerson.公司
      } else {
        this.isXiehuiCompany = false
        this.company = this.radish.公司
      }
    },
    sortExpByTime(exps) {
      exps.sort((a, b) => {
        const start = a.起始时间 && Date.parse(a.起始时间) ? dateformat(a.起始时间, 'yyyy.mm.dd') : '0'
        const end = b.起始时间 && Date.parse(b.起始时间) ? dateformat(b.起始时间, 'yyyy.mm.dd') : '0'
        return start < end ? 1 : -1
      })
      return exps
    },
    addToRight(exp, index) {
      if (exp.hasAdd) {
        return
      }
      exp.hasAdd = true
      this.rightExps.push(exp)
      const rightExps = this.rightExps.slice(0)
      this.rightExps = this.sortExpByTime(rightExps)
      this.leftExps[index] = exp
      // this.leftExps.splice(index, 1)
    },
    addAllToRight() {
      const rightExps = this.rightExps.slice(0)
      for (const exp of this.leftExps) {
        if (!exp.hasAdd) {
          rightExps.push(exp)
        }
      }
      this.rightExps = this.sortExpByTime(rightExps)
      this.leftExps.forEach(v => {
        v.hasAdd = true
      })
    },
    async deleteRight(exp, index) {
      if (!this.delExpHelper) {
        this.loading = false
        return
      }
      if (!this.delExpHelper._id) {
        // this.leftExps.push(this.delExpHelper)
        this.leftExps.forEach(v => {
          if (v.index === this.delExpHelper.index) {
            v.hasAdd = false
          }
        })
        this.rightExps.splice(this.delExpIndex, 1)
      } else {
        const deRes = await app.service('radish').deleteExperience({ _id: this.delExpHelper._id })
        if (deRes.status === 'success') {
          this.rightExps.splice(this.delExpIndex, 1)
        }
      }
      this.loading = false
      this.dialogVisible2 = false
    },
    async confirmDeleteRight(exp, index) {
      this.delExpHelper = exp
      this.delExpIndex = index
      this.loading = true
      this.dialogVisible2 = true
    },
    async syncCompany() {
      // if (!this.person.公司) return this.$message.error('协会公司为空')
      // this.$confirm('是否同步添加工作经历?', '提示', {
      //   confirmButtonText: '添加经历',
      //   cancelButtonText: '不添加经历',
      //   type: 'warning',
      // })
      //   .then(async () => {
      //     await this.bindThird(this.person, true)
      //   })
      //   .catch(async () => {
      //     await this.updateCompany(this.person.公司)
      //   })
      this.loading = true
      this.dialogVisible3 = true
    },
    async updateCompany(companyName) {
      this.loading = true
      let company = companyName
      const res = await app.service('company').serchCompanyName(companyName)
      if (res && res.status === 'success') {
        const altCompany = res.data
        if (altCompany.length > 0) {
          company = altCompany[0].公司
        }
      }
      await app.service('radish').modifyById({ _id: this.radish._id, data: { 公司: company, status: 2 } })
      this.radish.公司 = company
      this.status = 2
      this.radish.status = 2
      this.bindText = '(已绑定)'
      this.refreshRadishList()
      this.loading = false
      this.dialogVisible3 = false
      this.$message.success('公司同步成功')
    },
    async confirmBind() {
      this.loading = true
      // 更新公司
      try {
        // if (this.company !== this.radish.公司) {
        //   await this.updateCompany(this.company)
        // }
        // 绑定人选
        if (!this.hasBind) {
          if (this.bindPerson.来源 === 'amac') {
            const res = await app
              .service('statistics')
              .bindAmacPerson({ _id: this.bindPerson._id, rid: this.radish._id })
            if (res.status === 'success') {
              this.$set(this.radish, 'status', this.company === this.radish.公司 ? 2 : 3)
              this.person = this.bindPerson
              this.$message.success('绑定成功')
            } else this.$message.error(res.msg)
          } else if (this.bindPerson.来源 === 'sac') {
            const res = await app
              .service('statistics')
              .bindStockPerson({ _id: this.bindPerson._id, rid: this.radish._id })
            if (res.status === 'success') {
              this.$set(this.radish, 'status', this.company === this.radish.公司 ? 2 : 3)
              this.person = this.bindPerson
              this.$message.success('绑定成功')
            } else this.$message.error(res.msg)
          }
        }
        // 增加经历
        const addExps = this.rightExps.filter(item => !item._id)
        if (addExps.length > 0) {
          const eRes = await app.service('radish').addExperience(addExps)
          if (!eRes || eRes.status == 'fail') {
            this.$message.error(eRes.msg)
          } else {
            this.$message.success('人选经历更新成功')
          }
        }
        // 刷新人选
        await this.modifyRenzhi()
        const radish = await this.getRadish()
        this.primaryLayoutShow = true
        this.secondaryLayoutShow = false
        this.show(radish)
        this.refreshRadishList()
      } catch (e) {
        this.$message.error('绑定失败', e.message)
      }
      this.loading = false
    },
    refreshRadishList() {
      app.root.$refs.main &&
        app.root.$refs.main.$refs.radishList &&
        app.root.$refs.main.$refs.radishList.loadOne(this.radish._id)
      app.root.$refs.main &&
        app.root.$refs.main.$refs.radishListPro &&
        app.root.$refs.main.$refs.radishListPro.loadOne(this.radish._id)
    },
    async replaceAllExps() {
      for (const exp of this.exps) {
        try {
          await app.service('radish').deleteExperience({ _id: exp._id })
        } catch (e) {
          this.$message.error(`删除经历${exp._id}失败：${e.message}`)
          continue
        }
      }
      this.rightExps = this.sortExpByTime(this.leftExpsBackup)
      this.leftExps = []
      await this.confirmBind()
      this.dialogVisible1 = false
      this.loading = false
    },
    replaceAllExpsConfirm() {
      this.dialogVisible1 = true
      this.loading = true
    },
    valiTime(start, end) {
      if (start > end) {
        this.$message.warning('结束时间不能早于起始时间')
      }
    },
    addExp() {
      const item = {}
      this.exps.unshift(item)
    },
    async delExp(index, content) {
      if (content._id) {
        this.loading = true
        const deRes = await app.service('radish').deleteExperience({ _id: content._id })
        if (deRes.status == 'success') {
          this.exps.splice(index, 1)
          await this.modifyRenzhi(this.exp)
          this.$message.success({ duration: 500, message: deRes.msg })
        } else {
          console.log(deRes.msg)
        }
        this.loading = false
      } else {
        this.exps.splice(index, 1)
      }
    },
    async saveExp() {
      this.loading = true
      const exp = this.exps
      for (const item of exp) {
        const keys = Object.keys(item)
        if (keys.length > 0) {
          // item.type = '工作'
          for (const k of keys) {
            // 去除空值
            if (!k) {
              delete item[k]
            }
          }
          if (item._id) {
            // dtEdit.push(item)
            const eeRes = await app.service('radish').modifyExperience({ query: { _id: item._id }, data: item })
            if (eeRes.status == 'fail') {
              this.$message.error(eeRes.msg)
            }
          } else {
            item.rid = this.radish._id
            item.type = '工作'
            const eRes = await app.service('radish').addExperience([item])
            if (!eRes || eRes.status == 'fail') {
              this.$message.error(eRes.msg)
              return
            }
            item._id = eRes.data.ids[0]
          }
        }
      }
      this.primaryLayoutShow = true
      this.thirdLayoutShow = false
      await this.modifyRenzhi(exp)
      this.radish = await this.getRadish()
      this.exps = await this.getRadishExps()
      await this.refreshRadishList()
      this.loading = false
    },
    async editExps() {
      this.exps = await this.getRadishExps()
      this.primaryLayoutShow = false
      this.thirdLayoutShow = true
    },
    async unbindThird() {
      this.loading = true
      const res = await app.service('radish').unbindThirdV2({ rid: this.radish._id })
      if (res && res.status === 'success') {
        this.$message.success('解绑成功')
        this.radish.status = 1
        this.person = {}
        this.show(this.radish)
      }
      this.loading = false
    },
    async modifyRenzhi() {
      const exps = await this.getRadishExps(false)
      const validExps = Array.isArray(exps) ? exps : [exps].filter(Boolean)
      const sortedExps = validExps.sort((a, b) => (a.起始时间 ? (a.起始时间 < b.起始时间 ? 1 : -1) : 1))
      await app.service('radish').modifyRenzhi({
        _id: this.radish._id,
        exp: sortedExps,
      })
    },
  },
}
</script>
<style>
.simi-wapper-v2 .el-card__header {
  padding: 10px 20px !important;
}
#simi-dialog-v2 .el-card__body {
  padding: 5px !important;
}
</style>
<style scoped>
.simi-box {
  padding: 5px 0;
  overflow: auto;
}
.simi-wapper {
  padding: 5px 5px;
  width: 100%;
  height: 100%;
  overflow: auto;
}
.lg-font {
  font-size: 16px;
}
.xl-font {
  font-size: 18px;
}
.md-font {
  font-size: 14px;
}
.sm-font {
  font-size: 12px;
}
.bold-font {
  font-weight: 600;
}
.subtitle-color {
  color: #999999;
}
.primary-text-color {
  color: #5e90b8;
}
.subtext-color {
  color: #666666;
}
.white-color {
  color: #ffffff;
}
.red-color {
  color: #ff0000;
}
.add-button-color {
  color: #0099ff;
}
.blue-color {
  color: #2578b5;
}
.orange-color {
  color: #ff6600;
}
.primary-button-color {
  background-color: #6a96a7;
}
.disable-button-color {
  background-color: #c9c9c9;
}
.gray-background-color {
  background-color: #cccccc;
}
.margin-left-md {
  margin-left: 15px !important;
}
.margin-vertical-md {
  margin: 10px 5px;
}
.margin-vertical-sm {
  margin: 5px 5px;
}
.margin-mid {
  margin: 10px 10px;
}
.radish-left-1-of-3 {
  position: fixed;
  top: 60px;
  left: 0;
  bottom: 0;
  background-color: #fff;
  width: 46vw;
  z-index: 1005;
  border: 1px solid #e1e1e1;
}
.radish-left-2-of-3 {
  position: fixed;
  top: 60px;
  left: 0;
  bottom: 0;
  background-color: #fff;
  width: 92vw;
  z-index: 1005;
  border: 1px solid #e1e1e1;
}
.cursor-pointer {
  cursor: pointer;
}
.dot-rectange-class {
  border: 1px dashed #cccccc;
  padding: 10px 5px;
  margin: 40px -5px;
}
.align-center {
  text-align: center;
  width: 100%;
  height: 100%;
}
.full-size {
  width: 100%;
  height: 100%;
}
.mid-size {
  width: 90%;
  height: 40%;
}
.title-td {
  background-color: #f2f2f2;
  color: #999999;
  width: 100px;
  font-size: 12px;
}
.text-td {
  width: 150px;
  font-size: 12px;
}
.left-side {
  height: 100%;
  width: 42vw;
  padding: 10px;
  background-color: #aec7db;
}
.left-bubble-rect {
  margin-top: 60px;
  border-radius: 10px;
  background-color: #ffffff;
  border: 1px solid #aec7db;
  position: relative;
  text-align: center;
  padding: 20px;
}
.left-bubble-rect::before,
.left-bubble-rect::after {
  position: absolute;
  top: 20px;
  right: -20px;
  content: '';
  width: 0;
  height: 0;
  border-right: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid #aec7db;
  border-top: 10px solid transparent;
}
.left-bubble-rect::after {
  right: -19px;
  border-left: 10px solid #ffffff;
}

.top-bubble-rect {
  height: 98%;
  width: 100%;
  border-radius: 10px;
  background-color: #ffffff;
  border: 1px solid #aec7db;
  position: relative;
  padding: 20px;
}
.top-bubble-rect::before,
.top-bubble-rect::after {
  position: absolute;
  top: -20px;
  right: 150px;
  content: '';
  width: 0;
  height: 0;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #aec7db;
  border-left: 10px solid transparent;
  border-top: 10px solid transparent;
}
.top-bubble-rect::after {
  top: -19px;
  border-bottom: 10px solid #ffffff;
}

.rde-exp-item {
  display: flex;
  padding-top: 10px;
}
.rde-exp-item .el-input {
  flex: 1;
}
.rde-exp-item .el-input .el-input--suffix .el-input__inner {
  padding-right: 0;
}
.rde-exp-icon {
  font-size: 14px;
  color: #409eff;
  cursor: pointer;
  margin-left: 5px;
  line-height: 28px;
}
.blue-color-2 {
  color: #334681;
}
.margin-md {
  margin: 10px;
}
.padding-md {
  padding: 10px;
}
.margin-bottom-md {
  margin-bottom: 10px;
}
.radish-exp-row {
  margin: 10px;
  padding: 5px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 600;
}
/* 气泡对话框 */
</style>
